import React, { useState, useEffect } from 'react';
import TrendingPostCard from '../PostCard/TrendingPostCard';
import axios from '../../Actions/axios.config';

const TrendingPostsm = () => {
  const [trendingPosts, setTrendingPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios.get(`/posts/getPosts/trending`)
      .then((response) => {
        setTrendingPosts(response.data.posts);
      })
      .catch((error) => console.error("Error fetching trending posts:", error))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <section className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12'>
      {/* Header Section */}
      <div className='text-center mb-12'>
        <div className="flex items-center justify-center gap-2 mb-4">
            <span className="px-3 py-1 text-xs font-bold tracking-wider text-orange-600 uppercase bg-orange-100 rounded-full">
                What's Hot
            </span>
        </div>
        <h1 className='text-4xl md:text-6xl font-extrabold text-gray-900 tracking-tight mb-4'>
          Discover the Top <span className="text-blue-600">Interview Experiences</span>
        </h1>
        <p className="text-gray-500 text-lg max-w-2xl mx-auto">
          Insights and success stories from students who cracked their dream companies.
        </p>
      </div>

      {/* Content Grid */}
      {isLoading ? (
        // Skeleton Loader
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
          {[1, 2, 3].map((n) => (
            <div key={n} className="h-64 bg-gray-200 animate-pulse rounded-2xl"></div>
          ))}
        </div>
      ) : trendingPosts.length > 0 ? (
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
          {trendingPosts.map((post) => (
            <div key={post.id} className="transition-transform duration-300 hover:-translate-y-2">
              <TrendingPostCard post={post} />
            </div>
          ))}
        </div>
      ) : (
        // Empty State
        <div className="text-center py-20 bg-gray-50 rounded-3xl border-2 border-dashed border-gray-200">
            <p className="text-gray-400">No trending experiences found right now. Check back later!</p>
        </div>
      )}
    </section>
  );
}

export default TrendingPostsm;